import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel, Spin } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

// Components
import Product from "../components/Product";

//Actions
import { getProducts as listProducts } from "../redux/actions/productActions";
import { Link } from "react-router-dom";
import { getCategories } from "../redux/actions/category";
import FeaturedProduct from "../components/FeaturedProduct";

const HomeScreen = ({ storeCurrency }) => {
  const dispatch = useDispatch();
  const getProducts = useSelector((state) => state.getProducts);
  const categoryList = useSelector((state) => state.category);
  const { products, loading } = getProducts;

  useEffect(() => {
    dispatch(listProducts());
    dispatch(getCategories());
  }, [dispatch]);

  return (
    <div className="container-fluid mx-auto">
      <Spin spinning={loading}>
        <div className="relative">
          <Carousel
            dots="true"
            dotPosition="bottom"
            autoplay
            autoplaySpeed={5000}
          >
            <div className="flex items-center justify-center">
              <div className="relative">
                <img
                  src="slider-1.png"
                  alt="Slider-Main"
                  className="slider-main"
                />
                <div className="absolute inset-1 inset-y-32 container flex flex-col items-center justify-center mx-auto">
                  <h1 className="heading_h1 text-white">
                    Your favorite Floristry & Decor Studio
                  </h1>
                  <div className="mb-12 max-w-sm text-white text-center">
                    Every Occasion Is Unique
                  </div>
                  <Link to="/shop" className="info__button">
                    Shop now
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-center ">
              <div className="relative">
                <img
                  src="slider-2.png"
                  alt="Slider-Main"
                  className="slider-main"
                />
                <div className="absolute inset-1 inset-y-32 container mx-auto">
                  <h1 className="heading_h1">
                    The florist to fulfill your <br />
                    bouquet needs
                  </h1>
                  <div className="mb-12 max-w-sm">100% Fresh love</div>
                  <Link to="/shop" className="info__button">
                    Shop now
                  </Link>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
        <div className="bg">
          <div className="container md:px-24 mx-auto py-20">
            <div className="flex items-center justify-center">
              <img src="/title-image.png" className="mb-4" alt="Flowers" />
            </div>
            <h2 className="heading_h2 text-center mt-2">Our New Arrivals</h2>
            {products?.length > 0 ? (
              <div className="md:grid grid-cols-2 gap-4 pt-20 md:m-0 m-4">
                {products?.slice(0, 4)?.map((product) => (
                  <FeaturedProduct
                    key={product._id}
                    name={product.name}
                    price={product.price}
                    image={product.image}
                    images={product.images}
                    _id={product._id}
                    storeCurrency={storeCurrency}
                    category={product.category.name}
                  />
                ))}
              </div>
            ) : (
              "No products available in this store."
            )}
            <div className="mt-20">
              <div className="md:grid grid-cols-4 gap-4 pt-20 md:m-0 m-4">
                <div>
                  <img
                    src="//cdn.shopify.com/s/files/1/0448/6476/6105/files/icon-7_medium.png?v=1613747541"
                    alt="Delivering Your Emotions"
                  />
                  <h6 className="my-4">
                    Emotions dressed with lovely flowers.
                  </h6>
                </div>
                <div>
                  <img
                    src="//cdn.shopify.com/s/files/1/0448/6476/6105/files/icon-7_medium.png?v=1613747541"
                    alt="Delivering Your Emotions"
                  />
                  <h6 className="my-4">
                    <strong>Delivering Your Emotions</strong>
                  </h6>
                  <p>
                    Send lovely flowers and gifts same day to surprise your
                    loved one
                  </p>
                </div>
                <div>
                  <img
                    src="//cdn.shopify.com/s/files/1/0448/6476/6105/files/icon-6_medium.png?v=1613747542"
                    alt="100% Fresh Flowers"
                  />

                  <h6 className="my-4">
                    <strong>100% Fresh Flowers</strong>
                  </h6>
                  <p>
                    Fresh Flower Basket, Cut Flowers &amp; more at lower price
                  </p>
                </div>
                <div>
                  <img
                    src="//cdn.shopify.com/s/files/1/0448/6476/6105/files/icon-5_medium.png?v=1613747542"
                    alt="Online Flowers Delivery"
                  />
                  <h6 className="my-4">
                    <strong>Online Flowers Delivery</strong>
                  </h6>
                  <p>
                    24/7 Flower &amp; Bouquet delivery with hassle free support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container md:px-24 mx-auto py-20">
          <div className="flex items-center justify-center">
            <img src="/title-image.png" className="mb-4" alt="Flowers" />
          </div>
          <h2 className="heading_h2 text-center mt-2">Featured Category</h2>
          <div className="md:grid grid-cols-4 gap-4 pt-20 md:m-0 m-4">
            {categoryList?.length > 0
              ? categoryList.map((category) => (
                  <div className="single_feature_post_text" key={category?._id}>
                    <h3>{category?.name}</h3>
                    <Link to="/shop" className="anker flex gap-2 items-center">
                      EXPLORE NOW <CaretRightOutlined />
                    </Link>
                  </div>
                ))
              : "No categories available in this store."}
          </div>
        </div>
        <div className="container md:px-24 mx-auto pb-20">
          <div className="flex items-center justify-center">
            <img src="/title-image.png" className="mb-4" alt="Flowers" />
          </div>
          <h2 className="heading_h2 text-center mt-2">All Products</h2>
          <div className="md:grid grid-cols-4 gap-4 pt-20 md:m-0 m-4">
            {products?.length > 0
              ? products
                  ?.filter((product) => product?.isFeatured === true)
                  ?.slice(0, 4)
                  ?.map((product) => (
                    <Product
                      key={product._id}
                      name={product.name}
                      price={product.price}
                      image={product.image}
                      _id={product._id}
                      storeCurrency={storeCurrency}
                    />
                  ))
              : "No products available in this store."}
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default HomeScreen;
